export * from "@vaadin/accordion/vaadin-accordion-panel.js";
export * from './generated/AccordionPanel.js';
